// extracted by mini-css-extract-plugin
export default {"container":"zV-z","title":"AV-z","link":"BV-z"};